export * from './landing.model';
export * from './landing.service';
export * from './landing-form.service';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/landings/shared/index.ts